import Config from '@config';

import { Flags } from './type';

export const defaultFlags: Flags = {
  featureLightDarkMode: Config.VITE_FEATURE_LIGHT_DARK_MODE === 'true',
  featureFlagsSwitcher: Config.VITE_FEATURE_FLAG_SWITCHER === 'true',
  featureShowLanguageSwitcher:
    Config.VITE_FEATURE_SHOW_LANGUAGE_SWITCHER === 'true',
  featureSessionManagement: Config.VITE_FEATURE_SESSION_MANAGEMENT === 'true',
};
